export type ChatSide = 'customer' | 'advisor' | 'system';
export type ChatEventKind =
  | 'text'
  | 'offer_sent' | 'offer_requested' | 'offer_confirmed' | 'offer_rejected' | 'offer_accepted'
  | 'offer_declined'
  | 'offer_withdrawn'
  | 'contract_ended';

export type ChatAttachment = {
  id: string;
  filename: string;
  file_size: number;
  mime_type: string;
  url: string;
};

export type ChatMessage = {
  id: string;
  side: ChatSide;
  sender_name: string;
  sender_email: string;
  sender_user_id: string;
  sender_avatar_url: string;
  body: string;
  kind: ChatEventKind;
  offer: string | null;
  created_at: string;
  attachments: ChatAttachment[];
};

export type ChatConversation = {
  id: string;
  customer_organization_id: string;
  advisor_organization_id: string;
  advisor_client_id: string | null;
  your_side: 'customer' | 'advisor';
  counterparty: string;
  counterparty_profile_id: string | null;
  counterparty_headline: string;
  counterparty_photo_url: string;
  is_open: boolean;
  closed_at: string | null;
  last_message_at: string | null;
  unread: number;
};

export type ConversationList = {
  roles: Array<'customer' | 'advisor'>;
  conversations: ChatConversation[];
};

export type AdvisorChangeReason =
  | 'responsiveness'
  | 'expertise'
  | 'communication'
  | 'price'
  | 'progress'
  | 'relationship_ended'
  | 'other';

export const ADVISOR_CHANGE_REASONS: Array<{ value: AdvisorChangeReason; label: string }> = [
  { value: 'responsiveness', label: 'Slow to respond' },
  { value: 'expertise', label: 'Not the right expertise' },
  { value: 'communication', label: 'Communication did not work' },
  { value: 'price', label: 'Price' },
  { value: 'progress', label: 'Not enough progress' },
  { value: 'relationship_ended', label: 'The engagement simply ended' },
  { value: 'other', label: 'Something else' },
];

export type AdvisorSwitch = { reason: AdvisorChangeReason; comment: string };

export type ReportMessageSide = 'customer' | 'platform' | 'system';

export type ReportMessage = {
  id: string;
  side: ReportMessageSide;
  sender_name: string;
  sender_email: string;
  sender_avatar_url: string;
  body: string;
  created_at: string;
  attachments: ChatAttachment[];
};

export type ReportThreadPayload = {
  report: {
    id: string;
    advisor_name: string;
    advisor_photo_url: string;
    reporter_organization_name: string;
    reporter_avatar_url: string;
    category_display: string;
    details: string;
    status: string;
    status_display: string;
    is_open: boolean;
    created_at: string;
    your_side: 'customer' | 'platform';
  };
  messages: ReportMessage[];
};

export type MyReport = {
  id: string;
  advisor_name: string;
  advisor_photo_url: string;
  category_display: string;
  status: string;
  status_display: string;
  last_message_at: string | null;
  unread: number;
  created_at: string;
};
